/**
* User management & login
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('member.info', {
            url: '/' + urls.member.infos.fr, // TODO : when multilang, change this to something dynamic
            abstract: true,
            views: {
                aside: {
                    templateUrl: 'src/views/member/member_aside.html'
                },
                content: {
                    controller: function ($scope, $rootScope, $filter, tools, nationalities) {
                        $scope.tools = tools;

                        // remove warning message
                        if ($scope.teaserPanel.css === 'info') {
                            angular.merge($scope.teaserPanel, { css: null, body: null });
                        }

                        if ($scope.breadcrumb.length > 2) {
                            $scope.breadcrumb.pop();
                        }
                        $scope.breadcrumb.push({ label: $filter('translate')('account.myAccountInfo'), state: 'member.info' });
                        $rootScope.title = $filter('translate')('account.title') + ' - ' + $filter('translate')('account.myInfos');
                        $rootScope.titlePanel = $filter('translate')('account.myAccountInfo');

                        $scope.submenu = [
                            { label: $filter('translate')('account.myInfo'), shortLabel: $filter('translate')('account.myInfoShort'), state: 'member.info.profil' },
                            // { label: $filter('translate')('account.myDocuments'), state: 'member.info.documents' }
                        ];

                        $scope.nationalities = {};
                        nationalities.forEach(function (item) {
                            $scope.nationalities[item.value] = item.name;
                        });
                    },
                    templateUrl: 'src/views/member/member_tabs.html'
                }
            }
        })
        .state('member.info.profil', {
            url: '',
            params: {
                message: null
            },
            views: {
                'subcontent': {
                    template:
                    '<p ng-if="refreshing" class="aqua-form--loader grid grid-middle grid-center"><span class="aqua-form--loader-text">Chargement en cours...</span></p>' +
                    '<div ng-if="!refreshing">' +
                    '  <div ui-view="profil"></div>' +
                    '  <div ui-view="coordinate"></div>' +
                    '</div>'
                },
                'profil@member.info.profil': {
                    controller: ['$scope', '$stateParams', function ($scope, $stateParams) {
                        $scope.message = $stateParams.message;
                    }],
                    templateUrl: 'src/views/member/member_info_profil.html'
                },
                'coordinate@member.info.profil': {
                    templateUrl: 'src/views/member/member_info_coordinate.html'
                }
            }
        })
        /*.state('member.info.documents', {
            url: '/' + urls.member.documents.fr, // TODO : when multilang, change this to something dynamic
            views: {
                subcontent: {
                    controller: ['$scope', 'drupal', 'lodash', 'profile', 'tools', 'moment', function ($scope, drupal, lodash, profile, tools, moment) {
                        $scope.renderType = function (type) {
                            return lodash.chain(type).split('/').last().value();
                        };

                        // medical certficate
                        $scope.certificate = {
                            label: 'account.documentMedicalCertificat',
                            labelAdd: 'account.documentMedicalCertificatAdd',
                            type: 'Certificat médical',
                            icon: 'medical-certificate',
                            new: {}
                        };

                        // documents
                        $scope.record = {
                            label: 'account.documentRecord',
                            labelAdd: 'account.documentRecordAdd',
                            type: 'Fiche de liaison',
                            icon: 'document',
                            new: {}
                        };

                        $scope.rules = {
                            label: 'account.documentRules',
                            labelAdd: 'account.documentRulesAdd',
                            type: 'Règle de fonctionnement',
                            icon: 'document',
                            new: {}
                        };
                        $scope.permissionauth = {
                            label: 'account.documentPermissionAuth',
                            labelAdd: 'account.documentPermissionAuthAdd',
                            type: 'Autorisation de sortie du territoire',
                            icon: 'document',
                            new: {}
                        };

                        // document needed
                        $scope.documents = [];
                        if (tools.isMinor($scope.member.field_date_de_naissance)) {
                            $scope.documents.push($scope.certificate, $scope.record, $scope.rules, $scope.permissionauth);
                        } else {
                            $scope.documents.push($scope.certificate);
                        }

                        // license form handler
                        $scope.license = {
                            identifier: profile.info.field_licence_number,
                            submitted: false,
                            state: profile.info.field_licence_status === 'ACTIF',
                            message: profile.info.field_licence_details
                        };
                        $scope.checkLicense = function () {
                            $scope.licenseForm.pending = true;
                            if ($scope.licenseForm.$valid) {
                                profile.amend({ field_ffv_licence: $scope.license.identifier }).then(function (result) {
                                    $scope.license.submitted = true;
                                    $scope.license.message = profile.info.field_licence_details;
                                    $scope.license.status = profile.info.field_licence_status === 'ACTIF';
                                    $scope.licenseForm.pending = false;
                                }).catch(function (error) {
                                    if (error.status === 403) {
                                        $scope.unauthorizedHandler();
                                    }
                                    $scope.licenseForm.pending = false;
                                });
                            } else {
                                $scope.licenseForm.pending = false;
                            }
                        };

                        $scope.user = {
                            handicap: profile.info.field_info_handicap
                        };

                        $scope.update = function () {
                            $scope.userForm.pending = true;
                            if ($scope.userForm.$valid) {
                                profile.amend($scope.user).then(function () {
                                    $scope.userForm.pending = false;
                                }).catch(function (error) {
                                    $scope.userForm.pending = false;
                                });
                            } else {
                                $scope.userForm.pending = false;
                            }
                        };

                        function loadFiles() {
                            drupal.getAccountFiles(profile.info.field_sfid).then(function (result) {
                                $scope.documents.forEach(function (document) {
                                    if (result[document.type]) {
                                        document.current = { name: document.label, icon: document.icon, uri: result[document.type].uri, created: result[document.type].created };
                                    }
                                });
                            });
                        }

                        $scope.upload = function (document) {
                            drupal.uploadAccountFile(profile.info.field_sfid, {
                                type: document.type,
                                filename: document.new[0].filename,
                                filemime: document.new[0].filemime,
                                data: document.new[0].data
                            }).then(loadFiles);
                        };

                        loadFiles();
                    }],
                    templateUrl: 'src/views/member/member_info_documents.html'
                }
            }
        });*/
}]);
